const data = {
  id: 0,
  title: "❤️ Demo",
  listCollection: [
    {
      cards: [
        {
          imageURL:
            "https://wordologybymbr.files.wordpress.com/2020/07/contact-me.jpg",
          assignee: "ironman",
          date: 23,
          deadline: "enter deadline (month date)",
          description: "Linkedin: https://www.linkedin.com/in/asamad35/",
          heading: "Contact me",
          hours: 22,
          id: "l3u0wdk7p",
          minutes: 51,
          month: "Mar",
          priority: "high",
          status: "Add status",
        },
        {
          imageURL:
            "https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg",
          assignee: "batman",
          date: 23,
          deadline: "september 1",
          description: "Learn NODE.JS to become a full stack developer",
          heading: "Learn NODE.JS",
          hours: 22,
          id: "l3u0k7p",
          minutes: 51,
          month: "Mar",
          priority: "moderate",
          status: "Add status",
        },
        {
          assignee: "choose 1: batman, ironman, hulk",
          date: 23,
          deadline: "enter deadline (month date)",
          description: "Add card description",
          heading: "Add card heading",
          hours: 22,
          id: "l3u0wdddk7p",
          minutes: 51,
          month: "Mar",
          priority: "low",
          status: "Add status",
        },
      ],
      heading: "Pending",
      id: "l13szot",
    },
    {
      cards: [
        {
          imageURL: "https://i.ytimg.com/vi/41GSinwoMYA/maxresdefault.jpg",
          assignee: "batman",
          date: 23,
          deadline: "sept 1",
          description: "Learning DSA will help in logic building",
          heading: "DSA in javascript",
          hours: 22,
          id: "l3uk7p",
          minutes: 51,
          month: "Mar",
          priority: "high",
          status: "Add status",
        },
        {
          imageURL:
            "https://www.mindinventory.com/blog/wp-content/uploads/2019/06/reactjs-benefits.jpg",
          assignee: "hulk",
          date: 23,
          deadline: "sept 1",
          description: "Deep dive in React.js",
          heading: "Learn how react works under the hood",
          hours: 22,
          id: "l3uk7ddp",
          minutes: 51,
          month: "Mar",
          priority: "moderate",
          status: "Add status",
        },
      ],
      heading: "in process",
      id: "l13szt",
    },

    {
      cards: [
        {
          assignee: "hulk",
          date: 23,
          deadline: "enter deadline (month date)",
          heading: "Create a kanban board",
          description:
            "add CRUD functionality and use Firebase as a backend to store data",
          hours: 22,
          id: "l3up",
          minutes: 51,
          month: "Mar",
          priority: "low",
          status: "Add status",
        },
        {
          assignee: "batman",
          date: 23,
          deadline: "enter deadline (month date)",
          heading: "Practice React",
          description: "practice react by making projects",
          hours: 22,
          id: "l3udwp",
          minutes: 51,
          month: "Mar",
          priority: "low",
          status: "Add status",
        },
      ],
      heading: "Done",
      id: "l1zt",
    },
  ],
};

export default data;
